/** Meal-level BBS from API — never fall back to ghi_score for display. */
export function getMealBbsScore(meal: Record<string, unknown> | null | undefined): number | null {
  if (!meal) return null;
  const spike = meal.glucose_spike as Record<string, unknown> | null | undefined;
  const raw = meal.bbs_score ?? spike?.bbs_score;
  if (raw == null || raw === "") return null;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
}

export function getMealBbsLabel(meal: Record<string, unknown> | null | undefined): string | null {
  if (!meal) return null;
  const spike = meal.glucose_spike as Record<string, unknown> | null | undefined;
  const label = meal.bbs_label ?? spike?.bbs_label;
  return typeof label === "string" && label.trim() ? label.trim() : null;
}

export function getMealBbsReasons(meal: Record<string, unknown> | null | undefined): string[] {
  if (!meal) return [];
  const fromBbs = meal.bbs_reasons;
  if (Array.isArray(fromBbs) && fromBbs.length > 0) {
    return fromBbs.filter((r): r is string => typeof r === "string" && r.trim() !== "");
  }
  return [];
}

/** Improvement tips shown under BBS — prefer bbs_reasons, else ghi_reasons when BBS exists. */
export function getMealBbsTipReasons(meal: Record<string, unknown> | null | undefined): string[] {
  const bbsReasons = getMealBbsReasons(meal);
  if (bbsReasons.length > 0) return bbsReasons;
  if (getMealBbsScore(meal) == null) return [];
  const fromGhi = meal.ghi_reasons;
  if (Array.isArray(fromGhi)) {
    return fromGhi.filter((r): r is string => typeof r === "string" && r.trim() !== "");
  }
  return [];
}
